module.exports = __webpack_public_path__ + "static/media/empty-state-template-srp.709e3777.svg";